const RISK_ASSESSMENT_MODULE_SLUG = "risk_assessment";

export const getAssessmentGapModuleSlug = (gap) => {
    if (!gap || typeof gap !== "object") {
        return "";
    }

    const slug = gap.moduleSlug ?? gap.module_slug ?? "";

    return typeof slug === "string" ? slug.trim() : "";
};

/**
 * Risk-assessment questionnaire gaps with this module slug are risk conditions
 * (DPIA follow-up), not documentation gaps.
 */
export const isRiskAssessmentCondition = (gap) => {
    return getAssessmentGapModuleSlug(gap) === RISK_ASSESSMENT_MODULE_SLUG;
};
